import * as React from 'react';
import Footer from 'components/organisms/Footer/GlobalFooter';
import MobileFooter from 'components/organisms/Footer/MobileGlobalFooter';
import Header from 'components/organisms/Header/CreateFundHeader';
import Body from 'views/MobileViews/CreateFund';
import { CreateFundPageProvider } from 'context';
import Media from 'react-media';
import HeaderMobile from 'components/organisms/Header/MobileHomeHeader';

const CreateFund = () => {
  type pageType = {
    details: boolean;
    jackpot: boolean;
    avm: boolean;
  };

  const [contentPage, setContentPage] = React.useState<pageType>({
    details: true,
    jackpot: false,
    avm: false,
  });

  const isDetails = (): void => {
    setContentPage({ details: true, jackpot: false, avm: false });
  };
  const isJackpot = (): void => {
    setContentPage({ details: false, jackpot: true, avm: false });
  };
  const isAvm = (): void => {
    setContentPage({ details: false, jackpot: false, avm: true });
  };

  return (
    <>
      <CreateFundPageProvider>
        <Media query="(max-width: 599px)">
          {matches =>
            matches ? (
              <HeaderMobile />
            ) : (
              <Header Details={isDetails} Jackpot={isJackpot} Avm={isAvm} />
            )
          }
        </Media>
        <Body page={contentPage} />

        <Media query="(max-width: 599px)">
          {matches => (matches ? <MobileFooter /> : <Footer />)}
        </Media>
      </CreateFundPageProvider>
    </>
  );
};

export default CreateFund;
